import React, { useRef } from 'react'
import useStyles from './Styles'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import { ISelectMedialFilePanelProps } from '../Interfaces'
import { Grid, Typography, Button, Paper } from '@material-ui/core'

const SelectMedialFilePanel: React.FC<ISelectMedialFilePanelProps> = ({
  file,
  error,
  setFile,
  doUpload,
  clearFile,
  isUploading
}) => {
  const classes = useStyles()
  const ref = useRef<HTMLInputElement>()

  const handleOpenFiles = (event: React.MouseEvent<HTMLElement>) => {
    ref.current.click()
    event.stopPropagation()
  }

  const getSelectFilePanel = () => {
    return (
      <React.Fragment>
        <Grid
          container
          justify="center"
          alignContent="center"
          onClick={handleOpenFiles}
          id="media-upload-file-select-file-panel"
          className={classes.uploadContainer}
        >
          <Grid className={classes.selectFileLabel} id="media-upload-select-file-label">
            Select File
          </Grid>
        </Grid>
        <Typography className={classes.labelMaximumSize} id="media-upload-file-size-label">
          Maximum file upload size: 5MB
        </Typography>
      </React.Fragment>
    )
  }

  const getSelectedFilePanel = () => {
    return (
      <Grid container justify="flex-end" alignItems="baseline" className={classes.selectedFileContainer}>
        <Grid container direction="row" className={classes.selectedFileNameContainer}>
          <AttachFileIcon id="media-upload-file-selected-attach-icon" className={classes.attachFileIcon} />
          <Grid item xs={9} className={classes.fileNameContainer}>
            <Typography className={classes.fileNameLabel} id="media-upload-file-selected-file-name-label">
              {file.name}
            </Typography>
          </Grid>
          <Grid item xs={2} className={classes.deleteSelectedFileContainer}>
            <Button
              id="media-upload-file-selected-delete-button"
              className={classes.deleteSelectedFileLink}
              onClick={clearFile}
              disabled={isUploading}
            >
              Delete
            </Button>
          </Grid>
        </Grid>
        <Button
          id="media-upload-file-selected-upload-button"
          variant="contained"
          type="submit"
          onClick={doUpload}
          disabled={isUploading}
        >
          Upload
        </Button>
      </Grid>
    )
  }

  return (
    <Grid item className={classes.mediaContainer}>
      <Paper className={classes.paper}>
        <Typography variant="subtitle1" id="media-upload-file-label-input-label">
          Media Upload
        </Typography>
        <Typography className={classes.uploadPdfLabel} variant="body2" id="media-upload-file-detail-label-input-label">
          Upload a PDF
        </Typography>
        <Typography className={classes.error} id="media-upload-file-error-label">
          {error}
        </Typography>
        <input
          className={classes.fileInput}
          ref={ref}
          type="file"
          data-testid="input-resume"
          onChange={e => {
            setFile(e.target.files[0])
            e.target.value = ''
          }}
          accept="application/pdf"
        />
        {!file && getSelectFilePanel()}
        {file && getSelectedFilePanel()}
      </Paper>
    </Grid>
  )
}

export default SelectMedialFilePanel
